import { css } from 'lit'
import { csColorBackground, csColorText, csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const indexStyles = css`
  :host {
    display: grid;
    justify-content: center;
    background-color: var(--csc-open-basket-banner-background-color, ${csColorBackground.warning});
  }
  
  .container {
    display: grid;
    grid-template-areas: "heading"
    "description"
    "info-block";
    grid-template-columns: 1fr;
    max-width: 100%;
    grid-column-gap: ${csSpacing.spacing08};
    grid-row-gap: ${csSpacing.spacing05};
    padding-top: ${csSpacing.spacing08};
    padding-right: ${csSpacing.spacing05};
    padding-bottom: ${csSpacing.spacing08};
    padding-left: ${csSpacing.spacing05};

    @media(min-width: ${SCREENS.medium}) {
      grid-template-areas: "heading info-block"
    "description info-block";
      grid-template-columns: 3fr 2fr;
      max-width: ${SCREENS.medium};
    }

    .heading {
      grid-area: heading;

      cse-icon {
        color: var(--csc-open-basket-banner-icon-color, ${csColorFunctional.warning});
      }
    }

    .description {
      display: grid;
      grid-area: description;
      grid-row-gap: ${csSpacing.spacing05};

      cse-text {
        --cse-text-color: var(--csc-open-basket-banner-description-color, ${csColorText.body});
      }
    }

    .info-block {
      display: block;
      width: max-content;
      grid-area: info-block;
      padding-top: ${csSpacing.spacing05};
      padding-right: ${csSpacing.spacing05};
      padding-bottom: ${csSpacing.spacing05};
      padding-left: ${csSpacing.spacing05};
      background-color: var(--csc-open-basket-banner-info-block-background-color, ${csColorBackground.primary});

      .stack {
        display: grid;
        grid-template-rows: repeat(2, 1fr);
      }
    }
  }
`
